import { gql } from '@apollo/client'

// Minimal post selection used to seed the CreateEditPost editor and gate the
// edit affordance (via channel.viewerIsOwner).
export const GET_POST_FOR_EDIT = gql`
  query GetPostForEdit($id: ID!) {
    post(id: $id) {
      id
      text
      status
      linkUrl
      linkTitle
      photos {
        id
        url
      }
      channel {
        id
        viewerIsOwner
      }
    }
  }
`
